module.exports = __webpack_public_path__ + "img/gb6170-86__m10.prt.ab9ec8f5.jpg";